//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ProductCard',
  components: '',
  data() {
    return {
      overlay: false
    }
  },
  props: [
    'productTitle',
    'image',
    'variantTitle',
    'productId',
    'variantId'
  ],
  methods: {
    updateProduct() {
      const data = {
        overlay: true
      }
      this.$emit('update-product', data)
    }
  }
}
